<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateCompany"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.company.color"
    :dialogName="resourceTitle"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="CreateCompany"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetCompanyGeneral
        :item="item"
        display-fetch-by-tax-number
        @input="evh_5534025912102772_input($event, {})"
      >
      </FieldsetCompanyGeneral>
      <div
        v-if="item.addresses && item.addresses.length"
      >
        <ItpText
          uppercase
          :text="'Address'|pgettext('CreateCompany')"
        >
        </ItpText>
        <HR>
        </HR>
        <FieldsetAddress
          :address="item.addresses[0]"
        >
        </FieldsetAddress>
      </div>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="messages.submitButtonText[role]"
      type="submit"
      :form="forms[formName]"
      :spinning="actions.create.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.create.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateCompany extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  role!: string;

  @Watch('role')
  onRole(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("role")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateCompany', {
      emails: null,
      role: this.role,
      relation: this.role === 'company' ? 'na' : 'customer'
    })
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['messages', 'item', 'formName', 'formId', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          create: {
            own: this.$fn.pgettext("Company|Header", "New own company"),
            partner: this.$fn.pgettext("Company|Header", "New partner"),
          }
          ,
          resourceTitle: {
            own: this.$fn.pgettext("Company|ResourceTitle", "Company"),
            partner: this.$fn.pgettext("Company|ResourceTitle", "Partner"),
          }
          ,
          submitButtonText: {
            own: this.$fn.pgettext("Button", "Create company"),
            partner: this.$fn.pgettext("Button", "Create partner"),
          }
          ,
        }
        ,
        item: null,
        formName: "company",
        formId: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.messages.resourceTitle[this.role]
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.messages.create[this.role],
        icon: this.$config.company.icons[this.role],
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2730_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2730, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_2736_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_2736, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_2738_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_2738, alias=undefined
    return {
      location: {
        name: "app.company",
        params: {
          id: $event.data.response.data.id,
        }
        ,
      }
      ,
    }
  }

  async act_1040167445267876_reloadSlickgrid_2740_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_2740, alias=undefined
    return {
      grid: "companies",
    }
  }

  async act_1040167445267876_request_2734_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_2734, alias=create
    return {
      operation: "create_company",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_setData_2742_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5534025912102772_setData_2742, alias=undefined
    return {
      path: "item",
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5534025912102772_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_input.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2730: actions.CloseModalAction;
    evh_7315092382398562_close_2729: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_2732: actions.CloseModalAction;
    evh_2248226175642056_close_2731: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_2736: actions.CloseComponentAction;
    evh_1040167445267876_success_2735: actions.EventHandlerImpl;
    act_1040167445267876_navigate_2738: actions.NavigateAction;
    evh_1040167445267876_success_2737: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_2740: actions.ReloadSlickgridAction;
    evh_1040167445267876_success_2739: actions.EventHandlerImpl;
    act_1040167445267876_request_2734: actions.RequestAction;
    evh_1040167445267876_submit_2733: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_setData_2742: actions.SetDataAction;
    evh_5534025912102772_input_2741: actions.EventHandlerImpl;
    evh_5534025912102772_input: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_2744: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_2743: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2730 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2730_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2729 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2730,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2729],
      }
    );
    const act_2248226175642056_closeModal_2732 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2731 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_2732,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2731],
      }
    );
    const act_1040167445267876_closeComponent_2736 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_2736_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2735 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_2736,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_navigate_2738 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_2738_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2737 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_2738,
        event: "success",
        displayName: "navigate",
      }
    );
    const act_1040167445267876_reloadSlickgrid_2740 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_2740_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_2739 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_2740,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_request_2734 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_2734_getActionArgs,
        displayName: "create",
        events: [evh_1040167445267876_success_2735, evh_1040167445267876_success_2737, evh_1040167445267876_success_2739],
      }
    );
    const evh_1040167445267876_submit_2733 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_2734,
        event: "submit",
        displayName: "create",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_2733],
      }
    );
    const act_5534025912102772_setData_2742 = new actions.SetDataAction(
      {
        actionArgs: this.act_5534025912102772_setData_2742_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_input_2741 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_setData_2742,
        event: "input",
        displayName: "setData",
      }
    );
    const evh_5534025912102772_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_input_2741],
      }
    );
    const act_1419464017721962_closeComponent_2744 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2743 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_2744,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2743],
      }
    );
    return {
      act_7315092382398562_closeModal_2730,
      evh_7315092382398562_close_2729,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_2732,
      evh_2248226175642056_close_2731,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_2736,
      evh_1040167445267876_success_2735,
      act_1040167445267876_navigate_2738,
      evh_1040167445267876_success_2737,
      act_1040167445267876_reloadSlickgrid_2740,
      evh_1040167445267876_success_2739,
      act_1040167445267876_request_2734,
      evh_1040167445267876_submit_2733,
      evh_1040167445267876_submit,
      act_5534025912102772_setData_2742,
      evh_5534025912102772_input_2741,
      evh_5534025912102772_input,
      act_1419464017721962_closeComponent_2744,
      evh_1419464017721962_clickPreventStop_2743,
      evh_1419464017721962_clickPreventStop,
      create: act_1040167445267876_request_2734,
    }
  }
}

Vue.component("CreateCompany", CreateCompany);

</script>